import { get } from 'lodash';

const getRestApiErrorPayload = (error) => {
  const rawBody = get(error, 'response.body');

  if (!rawBody) {
    return null;
  }

  if (typeof rawBody === 'object') {
    return rawBody;
  }

  if (typeof rawBody !== 'string') {
    return null;
  }

  try {
    return JSON.parse(rawBody);
  } catch (parseError) {
    return null;
  }
};

const createErrorMessage = (error, printStack = false) => {
  const restApiErrorPayload = getRestApiErrorPayload(error);

  const message = get(error, 'response.data.error.message')
    || get(error, 'response.data.message')
    || get(restApiErrorPayload, 'error.message')
    || get(restApiErrorPayload, 'message')
    || get(error, 'response.message')
    || get(error, 'message')
    || 'Unknown error';
  const code = get(error, 'response.data.error.code')
    || get(error, 'response.data.code')
    || get(restApiErrorPayload, 'error.code')
    || get(restApiErrorPayload, 'code')
    || '';
  const { stack } = error;
  return `${message}${code ? ` (code ${code})` : ''}${printStack ? `\n\n${stack}` : ''}`;
};

const mockApiError = (message, code = '') => ({
  response: {
    data: {
      error: {
        code,
        message,
      },
    },
  },
});

const getDefaultFunctions = functions => Object.keys(functions)
  .reduce((result, key) => ({
    ...result,
    [key]: () => { },
  }), {});

export {
  createErrorMessage,
  getDefaultFunctions,
  mockApiError,
};
